import { customEvent } from "goi_common";

interface NearbyParlor {
  id: number;
  companyname: string;
  sido: string;
}

interface DirectionsNearbyProps {
  companyName: string;
  sigunguName: string;
  nearbyParlors: NearbyParlor[];
}

export const DirectionsNearby = ({
  companyName,
  sigunguName,
  nearbyParlors,
}: DirectionsNearbyProps) => {
  if (nearbyParlors.length === 0) return null;

  return (
    <section className="dr-section" aria-labelledby="dr-nearby-title">
      <h2 id="dr-nearby-title" className="dr-section__title">
        {`${sigunguName} 다른 장례식장 찾아가시는 길`}
      </h2>
      <p className="dr-section__lede">
        {`${sigunguName}에 위치한 인근 장례식장의 찾아가시는 길도 확인하실 수 있습니다. ${companyName} 외 다른 장례식장 위치를 비교해 보세요.`}
      </p>
      <ul className="dr-nearby">
        {nearbyParlors.map((p) => (
          <li key={p.id} className="dr-nearby__item">
            <a
              className="dr-nearby__link"
              href={`/directions/${p.id}/`}
              onClick={() =>
                customEvent({
                  newGtm: {
                    path: "prlr_directions",
                    trigger_and_target: "btn_nearby_directions",
                  },
                })
              }
            >
              {`${p.companyname} 찾아가시는 길 →`}
            </a>
          </li>
        ))}
      </ul>
    </section>
  );
};
